export const clearPhoneNumber = (value: string) => {
  return value.replace(/[^+\d]/g, '');
};
